export default __webpack_public_path__ + "static/media/blue-candy.73120c15.png";